import(/* webpackMode: "eager" */ "/codebuild/output/src1992310932/src/apps/junonkuji/src/components/form/LinkButton/LinkButton.module.scss");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1992310932/src/apps/junonkuji/src/components/ui/ImageView/ImageView.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1992310932/src/apps/junonkuji/src/components/ui/MediaPlayer/MediaPlayer.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1992310932/src/apps/junonkuji/src/features/article/components/ArticleBlocks/ArticleBlocks.module.scss");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1992310932/src/apps/junonkuji/src/features/article/components/ArticleHeader/ArticleHeader.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1992310932/src/apps/junonkuji/src/features/article/components/ArticleTagList/ArticleTagList.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1992310932/src/node_modules/next/dist/client/link.js");
